var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpAddressBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11903",
    "data-name": "Group 11903",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.041,
    height: 20,
    viewBox: "0 0 18.041 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3329",
    "data-name": "Rectangle 3329",
    width: 18.041,
    height: 20,
    fill: "#4a90f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11902",
    "data-name": "Group 11902",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10120",
    "data-name": "Path 10120",
    d: "M2.018,17.027c-.836-.087-1.865.243-2-1a.851.851,0,0,1,.7-.942,9.263,9.263,0,0,1,1.257-.107V12.983c-.294,0-.6.009-.914,0a.987.987,0,1,1,.022-1.967c.283-.006.567,0,.891,0V8.989c-.291,0-.57,0-.849,0a.994.994,0,1,1,0-1.969c.28-.007.561,0,.863,0v-2c-.807-.1-1.972.22-1.953-1.054.019-1.235,1.159-.9,1.981-.992,0-.359-.006-.693,0-1.027A1.944,1.944,0,0,1,3.958.009q6.061-.017,12.122,0a1.983,1.983,0,0,1,1.957,2.147q.006,7.183,0,14.365a11.421,11.421,0,0,1-.069,1.86A1.881,1.881,0,0,1,16.015,20Q10.007,20,4,19.994a1.95,1.95,0,0,1-1.981-2c0-.3,0-.6,0-.966M13.03,13.981A2.914,2.914,0,0,0,11.5,11.392a2.832,2.832,0,0,0-3.163.131,2.726,2.726,0,0,0-1.29,2.457ZM10.013,5.993a2.016,2.016,0,0,0-2.006,2A2.053,2.053,0,0,0,10,10.022a2.09,2.09,0,0,0,2.047-2.046,2.048,2.048,0,0,0-2.036-1.983",
    transform: "translate(0 0)",
    fill: "#4a90f7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpAddressBook);
export default __webpack_public_path__ + "static/media/op-address-book.5db594677f5fe9cde4d5a128f9934730.svg";
export { ForwardRef as ReactComponent };